const SET_ALL_LANGUAGES = 'LANGUAGES/SET_ALL_LANGUAGES'
const SET_LANGUAGE_ID_ACTIVE = 'LANGUAGES/SET_LANGUAGE_ID_ACTIVE'

export {SET_ALL_LANGUAGES, SET_LANGUAGE_ID_ACTIVE}
